import { watch } from 'vue';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { useProductsStore } from '@/store/productsStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import { useCategoriesStore } from '@/store/categoriesStore';
import { extractUrls } from './useExtractUrls';
import { extractProductData } from '@/helpers/product/extractProductData';
import { extractProductMainCategory } from '@/helpers/product/extractProductMainCategory';

export default function useProcessProduct() {
  const productsStore = useProductsStore();
  const urlSourcesStore = useUrlSourcesStore();
  const activeUrlStore = useActiveUrlStore();
  const categoriesStore = useCategoriesStore();

  watch(
    () => urlSourcesStore.getProductsSource,
    (productsSource) => {
      const toProcess = productsSource.filter(
        (u) => !productsStore.hasUrl(u.pathname)
      );

      toProcess.forEach(({ urlSource, pathname }) => {
        extractUrls(urlSource);

        // extract core product data
        const {
          name,
          metaTitle,
          metaDescription,
          price,
          specification,
          description,
          images,
        } = extractProductData(
          urlSource,
          pathname,
          activeUrlStore.getProvider,
          activeUrlStore.activeUrl
        );

        // figure out mainCategory (fallback to alphabetical first)
        let mainCategory = extractProductMainCategory(
          urlSource,
          pathname,
          activeUrlStore.getProvider
        );
        if (!mainCategory) {
          const categories = categoriesStore.getCategoryPathnamesByProductPath(pathname);
          if (categories.length) mainCategory = categories.sort()[0];
        }


        // add to store
        productsStore.addProduct(
          pathname,
          name,
          metaTitle,
          metaDescription,
          images,
          description,
          price,
          specification,
          mainCategory || '',
        );
      });
    },
    { immediate: true }
  );
}
